module.exports = __webpack_public_path__ + "img/2025-09-19e_1.e6c097ee.jpg";